import theme, { Theme } from './theme';

export default theme;
export type { Theme };
